export default function isOverflown($parse) {
  'ngInject';

  return function link($scope, $element, $attrs) {
    const assign = $parse($attrs.isOverflown).assign;
    $scope.$watch(() => {
      if ('isOverflownType' in $attrs) {
        if ($attrs.isOverflownType === 'x') {
          assign($scope, $element[0].scrollWidth > $element[0].clientWidth);
        } else if ($attrs.isOverflownType === 'y') {
          assign($scope, $element[0].scrollHeight > $element[0].clientHeight);
        }
      } else {
        assign(
          $scope,
          $element[0].scrollHeight > $element[0].clientHeight ||
            $element[0].scrollWidth > $element[0].clientWidth
        );
      }
    });
  };
}
